import script from "./TressSalesmanInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressSalesmanInfo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__